import { StyleSheet, TouchableOpacity, View } from "react-native";

import { CheckSolid, ExclamationCircleOutline } from "@smartrent/icons";
import { ThemeColors, Typography, useTheme } from "@smartrent/ui";

export interface ToastNotificationProps {
  label: string;
  type?: "default" | "warning" | "error" | "knowledge" | "success";
  icon?: "check" | "exclamation";
  action?: {
    label: string;
    onPress: () => void;
  };
  active?: boolean;
  delayBeforeHide?: number;
}

const getBackgroundColor = (type: string, colors: ThemeColors) => {
  switch (type) {
    case "warning":
      return colors.warning;

    case "error":
      return colors.error;

    case "knowledge":
      return colors.info;

    case "success":
      return colors.success;

    default:
      return colors.primary;
  }
};

const getIcon = (icon: string) => {
  switch (icon) {
    case "check":
      return <CheckSolid color="#fff" />;
    default:
      return <ExclamationCircleOutline color="#fff" />;
  }
};

export default function ToastNotification({
  label,
  type = "default",
  icon,
  action,
}: ToastNotificationProps) {
  const { colors } = useTheme();

  return (
    <View
      style={[
        styles.root,
        {
          backgroundColor: getBackgroundColor(type, colors),
        },
      ]}
    >
      <View style={{ alignItems: "center", flex: 1, flexDirection: "row" }}>
        {icon && <View style={{ marginRight: 12 }}>{getIcon(icon)}</View>}
        <Typography numberOfLines={2} style={styles.text}>
          {label}
        </Typography>
      </View>
      {action && (
        <TouchableOpacity onPress={action.onPress}>
          <Typography
            style={[
              styles.text,
              { paddingHorizontal: 8, textTransform: "uppercase" },
            ]}
          >
            {action.label}
          </Typography>
        </TouchableOpacity>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  root: {
    alignItems: "center",
    flexDirection: "row",
    height: 48,
    justifyContent: "space-between",
    paddingHorizontal: 16,
    width: "100%",
  },
  text: {
    fontSize: 14,
    fontWeight: "600",
    color: "#FFF",
    maxWidth: "100%",
    textOverflow: "ellipsis",
  },
});
